import React from 'react';
import { Input } from './input';
import { cn } from '../../lib/utils';
import {
  MONTH_MIN,
  MONTH_MAX,
  sanitizeMonthValue,
} from '../../utils/dateValidation';

export default function MonthInput({
  value,
  onChange,
  error,
  className,
  id,
  required,
  disabled,
  min = MONTH_MIN,
  max = MONTH_MAX,
  ...props
}) {
  const handleChange = (e) => {
    const sanitized = sanitizeMonthValue(e.target.value);
    if (sanitized === null) return;
    onChange?.(sanitized);
  };

  return (
    <div className="space-y-1">
      <Input
        id={id}
        type="month"
        min={min}
        max={max}
        value={value ?? ''}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        className={cn(error && 'border-destructive focus-visible:ring-destructive', className)}
        aria-invalid={Boolean(error)}
        {...props}
      />
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
